import { render, staticRenderFns } from "./TicketStatus.vue?vue&type=template&id=68f4b5ac&scoped=true&"
import script from "./TicketStatus.vue?vue&type=script&lang=js&"
export * from "./TicketStatus.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatus.vue?vue&type=style&index=0&id=68f4b5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4b5ac",
  null
  
)

export default component.exports